module.exports = __webpack_public_path__ + "static/UnboxingDoodle-58597a5f6bdf88731d551e954ddafebf.png";